import React, { useState } from "react";

const Search = () => {
  return (
      <input placeholder="search:" id="search"  />
  );
};

export default Search;